/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Events__InstructionsInputs */

const en_header_events__instructions = /** @type {(inputs: Header_Events__InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In some languages, 'calendar' or 'dates' might be better wordings for meeting the goal of a short translation. (German: Termine)`)
};

/**
* | output |
* | --- |
* | "In some languages, 'calendar' or 'dates' might be better wordings for meeting the goal of a short translation. (German: Termine)" |
*
* @param {Header_Events__InstructionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_events__instructions = /** @type {((inputs?: Header_Events__InstructionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Events__InstructionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_events__instructions(inputs)
});